import React, { Suspense } from 'react'
import { FormDependencyLoaderProvider } from '../../context/FormDependencyLoaderContext'
import Protected from '../../Protected'
import EnquiryView from './EnquiryView'

const EnquiryLanding = () => {
  return (
    <>
      <Suspense fallback={null}>
        <Protected>
          <div className="content-wrapper">
            <article className="main">
              <FormDependencyLoaderProvider>
                <EnquiryView />
              </FormDependencyLoaderProvider>
            </article>
          </div>
        </Protected>
      </Suspense>
    </>
  )
}

export default EnquiryLanding
